import React, { MouseEvent } from 'react'
import { BarGraph } from './BarGraph.d'
import BarGraphItem from './BarGraphItem'

interface BarGraphProps {
  graph: BarGraph[]
}

const BarGraphModule = (barGraph: BarGraphProps) => {
  const graph = barGraph.graph

  const querySelfOrChildren = (element: any, selector: any) => {
    if (element.matches(selector)) {
      return element
    } else {
      return element.querySelector(selector)
    }
  }

  const handleMouseEvent = (e: MouseEvent<HTMLSpanElement>) => {
    let target = e.currentTarget as HTMLSpanElement
    const bar = querySelfOrChildren(target, '.otl-bar-graph__bar')
    bar.style.width = '0%'
    bar.style.transition = 'none'

    setTimeout(() => {
      const graphItem = querySelfOrChildren(target, '.otl-bar-graph__item')
      const bar = querySelfOrChildren(graphItem, '.otl-bar-graph__bar')

      bar.style.width = `${graphItem.dataset.percentage}%`
      bar.style.transition = `width 0.8s ease-in-out`
    }, 500)
  }

  return (
    <section className='otl-bar-graph mt-7'>
      <div className='otl-bar-graph__container'>
        {graph.map((g: BarGraph, i: number) => (
          <BarGraphItem g={g} key={i} />
        ))}
      </div>
    </section>
  )
}

export default BarGraphModule
